import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { LabeledDropdownPills } from '@elliemae/ds-basic/Pills';
import useFocusGroupItem from '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';

var noop = function noop() {
  return null;
};

function FilterDropdownPill(_ref) {
  var groupIndex = _ref.groupIndex,
      groupId = _ref.groupId,
      label = _ref.label,
      _ref$pills = _ref.pills,
      pills = _ref$pills === void 0 ? [] : _ref$pills,
      onFocusGroupSet = _ref.onFocusGroupSet,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup,
      maxWidth = _ref.maxWidth,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? noop : _ref$onRemove,
      minWidth = _ref.minWidth;
  var ref = useRef(null);
  useFocusGroupItem(ref);

  var _pills$ = pills[0],
      _pills$$onSelectOptio = _pills$.onSelectOption,
      onSelectOption = _pills$$onSelectOptio === void 0 ? noop : _pills$$onSelectOptio,
      _pills$$onRemoveOptio = _pills$.onRemoveOption,
      onRemoveOption = _pills$$onRemoveOptio === void 0 ? noop : _pills$$onRemoveOptio,
      onChange = _pills$.onChange,
      options = _pills$.options,
      value = _pills$.value,
      type = _pills$.type,
      multi = _pills$.multi,
      fixed = _pills$.fixed,
      otherDropdownProps = _objectWithoutProperties(_pills$, ["onSelectOption", "onRemoveOption", "onChange", "options", "value", "type", "multi", "fixed"]);

  var selectOption = useCallback(function (option, optionIndex) {
    onSelectOption(option, {
      optionIndex: optionIndex,
      groupIndex: groupIndex,
      groupId: groupId
    });
  }, [groupId, value, options]);
  var removeOption = useCallback(function (option, optionIndex) {
    onRemove(option, {
      optionIndex: optionIndex,
      groupIndex: groupIndex,
      groupId: groupId
    });
    onRemoveOption(option, {
      optionIndex: optionIndex,
      groupIndex: groupIndex,
      groupId: groupId
    });
  }, [groupId, value, options]);
  return /*#__PURE__*/React.createElement(LabeledDropdownPills, _extends({}, otherDropdownProps, {
    id: groupId,
    innerRef: ref,
    label: label,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onChange: onChange,
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup,
    onRemove: removeOption,
    onSelect: selectOption,
    options: options,
    type: type || (multi ? 'multi' : 'single'),
    value: value,
    fixed: fixed
  }));
}

FilterDropdownPill.propTypes = {
  groupIndex: PropTypes.number,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  pills: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  onFocusGroupSet: PropTypes.func,
  onFocusNextGroup: PropTypes.func,
  onFocusPreviousGroup: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRemove: PropTypes.func,
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default FilterDropdownPill;
//# sourceMappingURL=FilterDropdownPill.js.map
